const Payment = ({ walletHidden, setPaymentType }) => {
  return (
    <div className="flex flex-col 2xl:flex-row gap-6">
      <div className="flex">
        <div className="flex w-[266px] lg:w-[300px] max-h-[130px] justify-center font-alliance-medium text-[20px] lg:text-[28px] bg-sec-grey-4 rounded-sm px-8 py-6">
          <img
            src={`/assets/logos/visa-mastercard.png`}
            alt="visa-mastercard-logo"
            className="object-contain"
          />
        </div>
        <div className="self-center">
          <input
            id="paymentType"
            name="paymentType"
            type="radio"
            value="tpv"
            className="h-7 w-7 ml-6 mr-3 border-blue text-blue focus:ring-blue"
            required={true}
            onChange={(e) => {
              setPaymentType(e.target.value)
            }}
          />
        </div>
      </div>
      <div className="flex">
        <div className="flex w-[266px] lg:w-[300px] max-h-[130px] justify-center font-alliance-medium text-[20px] lg:text-[28px] bg-sec-grey-4 rounded-sm px-8 py-6">
          <img
            src={`/assets/logos/bizum.png`}
            alt="bizum-logo"
            className="object-contain"
          />
        </div>
        <div className="self-center">
          <input
            id="paymentType"
            name="paymentType"
            type="radio"
            value="bizum"
            className="h-7 w-7 ml-6 mr-3 border-blue text-blue focus:ring-blue"
            required={true}
            onChange={(e) => {
              setPaymentType(e.target.value)
            }}
          />
        </div>
      </div>
      {!walletHidden && (
        <div className="flex">
          <div className="flex w-[266px] lg:w-[300px] max-h-[130px] justify-center items-center font-alliance-medium text-[20px] lg:text-[28px] bg-sec-grey-4 rounded-sm p-8">
            <h4 className="font-alliance-medium text-[25px] text-grey-blue">
              Moneder Virtual
            </h4>
          </div>
          <div className="self-center">
            <input
              id="paymentType"
              name="paymentType"
              type="radio"
              value="mv"
              className="h-7 w-7 ml-6 mr-3 border-blue text-blue focus:ring-blue"
              required={true}
              onChange={(e) => {
                setPaymentType(e.target.value)
              }}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default Payment
